<script>
import Opcion from "../ui/Opcion.vue";
import { mapGetters, mapActions } from "vuex";
import Burger from "../../views/Menu/Burger.vue";
import axios from "axios";

export default {
  name: "Sidebar",
  components: {
    Opcion,
    Burger,
  },
  props: {
    pantalla: Boolean,
  },
  data() {
    return {
      opciones: [
        {
          id: 1,
          icon: "chart-pie",
          ruta: "Dashboard",
          path: "dashboard",
          activo: false,
          title: "Dashboard",
          opciones: [],
          permisos: "dashboard.view",
        },
        {
          id: 2,
          icon: "box",
          ruta: "Despachos",
          path: "despachos",
          activo: true,
          title: "Despachos",
          opciones: [],
          permisos: "dispatch.view",
        },
        {
          id: 3,
          icon: "user",
          ruta: "Users",
          path: "usuarios",
          activo: false,
          title: "Usuarios",
          opciones: [],
          permisos: "users.view",
        },
        {
          id: 4,
          icon: "users",
          ruta: "Grupos",
          path: "grupos",
          activo: false,
          title: "Grupo de usuarios",
          opciones: [],
          permisos: "clients.manage",
        },
        {
          id: 5,
          icon: "user-tie",
          ruta: "Clients",
          path: "clientes",
          activo: false,
          title: "Clientes",
          opciones: [],
          permisos: "clients.manage",
        },
        {
          id: 6,
          icon: "file-alt",
          ruta: "Agentes",
          path: "agentes-carga",
          activo: false,
          title: "Agentes de Carga",
          opciones: [],
          permisos: "agentes.manage",
        },
        {
          id: 7,
          icon: "file-alt",
          ruta: "CompaniasNavieras",
          path: "companias-navieras",
          activo: false,
          title: "Compañias Navieras",
          opciones: [],
          permisos: "companias.manage",
        },
        {
          id: 8,
          icon: "flag",
          ruta: "Aduanas",
          path: "aduanas",
          activo: false,
          title: "Aduanas",
          opciones: [],
          permisos: "aduanas.manage",
        },
        {
          id: 9,
          icon: "star",
          ruta: "Extraportuarios",
          path: "extraportuarios",
          activo: false,
          title: "Extraportuarios",
          opciones: [],
          permisos: "extraportuarios.manage",
        },
        {
          id: 10,
          icon: "truck",
          ruta: "Proveedores",
          path: "proveedores",
          activo: false,
          title: "Proveedores",
          opciones: [],
          permisos: "providers.manage",
        },
        {
          id: 11,
          icon: "check",
          ruta: "vistos-buenos",
          path: "vistos-buenos",
          activo: false,
          title: "Vistos Buenos",
          opciones: [],
          permisos: "vistos-buenos.manage",
        },
        {
          id: 12,
          icon: "lock",
          ruta: "MantenedorCredenciales",
          path: "mantenedor-credenciales",
          activo: false,
          title: "Mantenedor credenciales",
          opciones: [],
          permisos: "credentials.manage",
        },
        {
          id: 13,
          icon: "book",
          ruta: "aforos",
          path: "aforos",
          activo: false,
          title: "Aforos",
          opciones: [],
          permisos: "aforos.manage",
        },
        {
          id: 14,
          icon: "dollar-sign",
          ruta: "Pagos",
          path: "pagos",
          activo: false,
          title: "Pagos",
          opciones: [],
          permisos: "aforos.manage",
        },
      ],
    };
  },
  watch: {
    $route: function () {
      let path = this.$route.path.split("/");
      this.opciones.forEach((el) => {
        if (el.path == path[1]) el.activo = true;
        else el.activo = false;
      });
    },
  },
  mounted() {
    let path = this.$route.path.split("/");
    this.opciones.forEach((el) => {
      if (el.path == path[1]) el.activo = true;
      else el.activo = false;
    });
  },

  methods: {
    ...mapActions({
      toggleNav: "nav/toggleNav",
    }),

    async descargarApk() {
      window.open(process.env.VUE_APP_API_URL + `/api/admin/apk-mobile`);
    },
  },
  computed: {
    ...mapGetters({
      isNavOpen: "nav/isNavOpen",
    }),
    isPanelOpen() {
      return this.isNavOpen;
    },
  },
};
</script>

<template>
  <nav class="relative h-[100vh] bg-white z-30">
    <div class="flex flex-row items-center justify-center p-8">
      <burger v-if="pantalla == true"></burger>
      <inline-svg src="../../assets/images/logo_aduanas.svg" title="My Image" />
    </div>
    <div class="sidebar-content">
      <ul>
        <Opcion
          v-bind:key="opcion.id"
          v-for="opcion in opciones"
          v-permisos="opcion.permisos"
          :opciones="opcion"
        ></Opcion>
        <li class="li-item">
          <a @click="descargarApk()">
            <fas :icon="['fas', 'download']"></fas>
            Descargar APK
          </a>
        </li>
      </ul>
    </div>
    <div class="sidebar-footer">
      <div class="sidebar-logo">
        {{ new Date().getFullYear() }}
      </div>
      <div class="br-footer"></div>
      <div class="sidebar-company">Agencia de Aduana Juan León</div>
    </div>
  </nav>
</template>

<style>
.sidebar {
  background: #ffffff;
  height: 100vh;
  position: relative;
}

.sidebar-content::-webkit-scrollbar-track {
  background: transparent;
}
.sidebar-content::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(70, 70, 70, 0.57);
}
.sidebar-content::-webkit-scrollbar {
  width: 4px !important;
}
.sidebar-content {
  padding: 5px 10px;
  overflow: auto;
  max-height: calc(100% - 137.55px - 66.06px);
}
.sidebar-content ul {
  list-style: none;
  padding: 0;
  text-align: left;
}
.li-item {
  border-bottom: 1px solid rgba(70, 70, 70, 0.07);
}
.li-item a:hover {
  color: #043161;
  background: rgba(222, 243, 255, 0.671);
}
.li-item a {
  color: #043161;
  display: block;
  padding: 17px 4px;
  text-decoration: none !important;
  outline: none;
  font-weight: 500;
  font-size: 12px !important;
}
.li-item:nth-child(5n + 1) svg {
  color: #5699f4 !important;
}
.li-item:nth-child(5n + 2) svg {
  color: #02be92 !important;
}
.li-item:nth-child(5n + 3) svg {
  color: #ffc72f !important;
}
.li-item:nth-child(5n + 4) svg {
  color: #e65b38 !important;
}
.li-item:nth-child(5n + 5) svg {
  color: #b45fe0 !important;
}

.li-item svg {
  font-size: 1rem;
  margin-right: 8px;
  color: #000;
  margin-left: 2px;
}

.seccion-activa {
  background: rgba(222, 243, 255, 0.671);
}
.seccion-activa a {
  font-weight: bold !important;
}

.sidebar-footer {
  bottom: 0;
  position: absolute;
  width: 100%;
  padding: 4%;

  gap: 4%;

  display: flex;
  flex-direction: row;
  text-align: left;

  cursor: default;
}

.sidebar-logo {
  display: flex;
  flex-direction: row;
  justify-content: center;
  place-items: center;
  padding: 2%;
  font-weight: 100;
}

.br-footer {
  background-color: #043161;

  width: 2px;
  height: auto;
}

.sidebar-company {
  display: flex;
  flex-direction: row;
  align-content: center;
  font-weight: 500;
}
</style>
